<template xmlns="http://www.w3.org/1999/html">
  <div class="p-3 rounded-lg border border-gray-300 flex gap-4 items-center">
    <digitization-avatar :project="project" size="3xl"  />
    <div>
      <p class="font-semibold text-xl sm:text-2xl">{{project.name}}</p>
      <p class="text-sm sm:text-base">{{summaryText}}</p>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    project: Object
  });

  const summaryText = computed(() => {
    const parts = [];
    if (props.project.videos_count > 0) parts.push(`${props.project.videos_count} Videos`);
    if (props.project.photos_count > 0) parts.push(`${props.project.photos_count} Photos`);
    if (props.project.audios_count > 0) parts.push(`${props.project.audios_count} Audio`);
    return `${props.project.files_count} Files (${parts.join(', ')})`;
  });
</script>
